import React from "react";
import { IHistory } from "../../interfaces/history";
import "../DetailsModal/DetailsModal.css";

interface Props {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  data: IHistory | null;
  loading?: boolean;
}

export const ConfirmConcludeModal = ({
  show,
  onHide,
  onConfirm,
  data,
  loading = false,
}: Props) => {
  if (!show || !data) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onHide();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-container">
        <button className="modal-close" onClick={onHide}>
          &times;
        </button>

        <h3 className="mb-3">Confirmar conclusão</h3>
        <p>Você deseja concluir a consulta da empresa:</p>
        <p>
          <strong>{data.companyName}</strong>
          <br />
          CNPJ: <strong>{data.document}</strong>
          <br />
          Protocolo: <strong>{data.protocol}</strong>
        </p>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <button className="btn btn-outline-secondary" onClick={onHide}>
            Cancelar
          </button>
          <button
            className="btn btn-success"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              />
            ) : null}
            {loading ? "Concluindo..." : "Confirmar"}
          </button>
        </div>
      </div>
    </div>
  );
};
